module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"emissions":"Emissionen","endEnergy":"Endenergie","primaryEnergy":"Primärenergie","scope":{"s12e":"Scope 1-2","s123e":"Scope 1-3","s1e":"Scope 1","s2e":"Scope 2","s3e":"Scope 3"},"energyDemand":{"ee":"Endenergiebedarf","pe":"Primärenergiebedarf"},"energyUsage":"Verwendungszweck","energyCarrier":"Energieträger","measurementData":"Messdaten","reductionPaths":"Absenkpfade"}}')
  delete Component.options._Ctor
}
